import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import PageLayout from "Layouts/PageLayout";
import Button from "Components/Button";
import PrintIcon from "Assets/SVG/PrintIcon";
import Pagination from "../../../Components/Pagination";
import useQueryParams from "../../../Hooks/UseQueryParams";
import { useFoilTypes} from "../../../Apis/FoilTypeApi";
import FoilTypeList from "../../../Features/Prints/Components/FoilTypeList";

const Index = () => {
    
    const { t } = useTranslation();

    const [ filter, setFilter ] = useQueryParams();

    const { data: foilTypes, isLoading } = useFoilTypes(filter);
    
    const navigate = useNavigate();
    
    return (
        <PageLayout title={t('foilTypes')} icon={<PrintIcon />} header={(
            <Button prefix={<PrintIcon fill={"#FFF"} />} text={t('createNewFoilType')} type={"primary"} onClick={() => navigate("new")} />
        )}>
            <>
                <FoilTypeList foilTypes={foilTypes?.items} isLoading={isLoading} />

                <Pagination paginatedList={foilTypes} onPageChange={newPage => setFilter({page: newPage})} />
            </>
        </PageLayout>
    )
}

export default Index
